import { Navigate } from 'react-router-dom';

import SuspenseLoader from 'src/components/SuspenseLoader';
import {
  AdminWorkspaceProvider,
  AdminWorkspaceState,
  useAdminWorkspace
} from './AdminWorkspaceProvider';

export const resolveAdminSessionDestination = (
  state: AdminWorkspaceState
): 'loading' | '/login' | '/dashboards/jobTracker' | '/platform' | string => {
  if (state.kind === 'legacy') return '/dashboards/jobTracker';
  if (state.kind === 'invalid-realm-session') return '/login';
  if (state.kind === 'platform') return '/platform';
  if (state.status === 'loading') return 'loading';
  if (state.status === 'error') return '/status/500';
  return `${state.workspace.routeBase}/dashboard`;
};

const AdminSessionEntryContent = () => {
  const state = useAdminWorkspace();
  const destination = resolveAdminSessionDestination(state);
  if (destination === 'loading') return <SuspenseLoader />;
  return <Navigate to={destination} replace />;
};

const AdminSessionEntry = () => (
  <AdminWorkspaceProvider>
    <AdminSessionEntryContent />
  </AdminWorkspaceProvider>
);

export default AdminSessionEntry;
